'use client';

import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import Accordion from '@alltrails/denali/components/Accordion';
import Heading from '@alltrails/denali/components/Heading';
import styles from './SidebarAccordion.module.scss';

type SidebarAccordionProps = Omit<ComponentProps<typeof Accordion>, 'title'> & {
  title: ReactNode;
  bodyClassName?: string;
  noBodyPadding?: boolean;
};

const SidebarAccordion = ({
  title,
  children,
  bodyClassName,
  noBodyPadding = false,
  initiallyOpen = true,
  borderBottomContainerClassName,
  buttonContainerClassName,
  ...rest
}: SidebarAccordionProps) => (
  <Accordion
    {...rest}
    initiallyOpen={initiallyOpen}
    title={
      <Heading as="h2" size="300">
        {title}
      </Heading>
    }
    borderBottomContainerClassName={classNames(styles.borderBottom, borderBottomContainerClassName)}
    buttonContainerClassName={classNames(styles.buttonContainer, buttonContainerClassName)}
  >
    {noBodyPadding ? children : <div className={classNames(styles.body, bodyClassName)}>{children}</div>}
  </Accordion>
);

export default SidebarAccordion;
